import {
  authButton,
  authLink,
  authSmallText,
  authSocialButton,
  colors,
  inputHint,
} from "../../theme";

const styles = {
  appleButton: authSocialButton,
  buttonConnexion: authButton,
  facebookButton: authSocialButton,
  googleButton: authSocialButton,
  linkPassword: {
    ...authLink,
    fontWeight: 500,
    color: colors.textSecondary,
  },
  linkTypo: authLink,
  smallText: authSmallText,
  // Starts where the rounded corner of the input above ends.
  // Same indent as the hints under the inputs of the sign up.
  forgotText: {
    ...authSmallText,
    pl: inputHint.pl,
  },
  smallLink: {
    ...authSmallText,
    fontWeight: 700,
    color: colors.text,
  },
};

export default styles;
